import { useEffect } from "react";

/**
 * Attach a `beforeunload` listener while `enabled` is true.
 * Triggers the browser's native "leave site?" dialog on tab close / reload /
 * external navigation. The dialog copy is dictated by the browser and cannot
 * be customized — that's a browser rule.
 *
 * Intra-app router navigation is handled separately via <Prompt>; this hook
 * only exists for hard-navigation leaks.
 */
export default function useBeforeUnload(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;

    const handler = (event) => {
      // Cross-browser: setting returnValue and returning a string both required
      // historically. Modern browsers only need preventDefault + returnValue.
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [enabled]);
}
